import React from 'react';
import { TargetIcon, TrendingUpIcon, BarChartIcon, PencilRulerIcon } from 'lucide-react';
export function ServicesSection() {
  // Function to handle navigation clicks with smooth scrolling
  const handleNavClick = sectionId => {
    // Prevent default anchor behavior
    event.preventDefault();
    // Get the target element to scroll to
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      // Scroll smoothly to the element
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      // Update URL without page reload
      history.pushState(null, null, `#${sectionId}`);
    }
  };
  return <section id="services" className="py-20 bg-gray-50" data-id="element-242">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
        <div className="text-center mb-16" data-id="element-244">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900" data-id="element-245">
            Facebook Ads That Drive Real Results
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-246">
            Our services are designed to deliver qualified leads and measurable
            ROI
          </p>
        </div>
        <div className="grid md:grid-cols-4 gap-6" data-id="element-247">
          <div className="bg-white rounded-xl overflow-hidden shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-2 group" data-id="element-248">
            <div className="h-2 bg-navy-600" data-id="element-249"></div>
            <div className="p-6" data-id="element-250">
              <div className="w-16 h-16 rounded-lg bg-navy-100 flex items-center justify-center mb-5 group-hover:bg-navy-200 transition-colors duration-300" data-id="element-251">
                <TargetIcon className="h-8 w-8 text-navy-800" data-id="element-252" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-253">
                Facebook Ads Management
              </h3>
              <p className="text-gray-600" data-id="element-254">
                Reach clients ready to buy your services
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl overflow-hidden shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-2 group" data-id="element-255">
            <div className="h-2 bg-navy-600" data-id="element-256"></div>
            <div className="p-6" data-id="element-257">
              <div className="w-16 h-16 rounded-lg bg-navy-100 flex items-center justify-center mb-5 group-hover:bg-navy-200 transition-colors duration-300" data-id="element-258">
                <TrendingUpIcon className="h-8 w-8 text-navy-800" data-id="element-259" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-260">
                Lead Generation
              </h3>
              <p className="text-gray-600" data-id="element-261">
                Convert prospects into high-value clients
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl overflow-hidden shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-2 group" data-id="element-262">
            <div className="h-2 bg-navy-600" data-id="element-263"></div>
            <div className="p-6" data-id="element-264">
              <div className="w-16 h-16 rounded-lg bg-navy-100 flex items-center justify-center mb-5 group-hover:bg-navy-200 transition-colors duration-300" data-id="element-265">
                <BarChartIcon className="h-8 w-8 text-navy-800" data-id="element-266" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-267">
                Campaign Optimization
              </h3>
              <p className="text-gray-600" data-id="element-268">
                Maximize ROI from every dollar spent
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl overflow-hidden shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-2 group" data-id="element-269">
            <div className="h-2 bg-navy-600" data-id="element-270"></div>
            <div className="p-6" data-id="element-271">
              <div className="w-16 h-16 rounded-lg bg-navy-100 flex items-center justify-center mb-5 group-hover:bg-navy-200 transition-colors duration-300" data-id="element-272">
                <PencilRulerIcon className="h-8 w-8 text-navy-800" data-id="element-273" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-274">
                Ad Creative Design
              </h3>
              <p className="text-gray-600" data-id="element-275">
                Attention-grabbing visuals that convert
              </p>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-276">
          <a href="#contact" className="inline-block px-8 py-4 rounded-md bg-navy-800 text-white font-bold text-lg hover:bg-navy-700 transition-all duration-300 hover:-translate-y-1" onClick={e => {
          e.preventDefault();
          handleNavClick('contact');
        }} data-id="element-277">
            Get Your Custom Ad Strategy
          </a>
        </div>
      </div>
    </section>;
}